import React from 'react';
import { last, get, trim } from 'lodash-es';
import Img from 'gatsby-image';
import ResultBaseInfo from './ResultBaseInfo';
import ResultBaseSection from './ResultBaseSection';

const lastSectionHasBottomImg = sections => {
  const lastSection = last(sections);
  return (
    lastSection && lastSection.photo && lastSection.photoPosition === 'Bottom'
  );
};
const ResultBase = ({ caseStudy }) => {
  // provide info about bottom images from previous sections
  const sections = caseStudy.frontmatter.sections.reduce(
    (prevSections, section) => {
      // eslint-disable-next-line no-param-reassign
      section.injectImageTop = lastSectionHasBottomImg(prevSections);

      return [...prevSections, section];
    },
    []
  );
  const techImg = get(caseStudy, 'frontmatter.images.technologies');

  const locationExists = caseStudy.frontmatter.technologies.sectionLocation;
  const titles = sections.map(el => el.title);
  const technologyAlreadyExists = titles.some(
    el => el.toLowerCase() === trim(locationExists).toLowerCase()
  );

  return (
    <>
      <ResultBaseInfo caseStudy={caseStudy} />

      {sections.length > 0 &&
        sections.map(section => (
          <ResultBaseSection
            technology={caseStudy.frontmatter}
            section={section}
            key={section.title}
          />
        ))}

      {!technologyAlreadyExists && (
        <div
          className={`storey ${
            lastSectionHasBottomImg(sections) ? 'inject-img-top' : ''
          }`}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-md-12">
                <div className="expanse-content text-format">
                  <h2>Used technology</h2>
                  <div className="technologies-beam">
                    <h3>The tech stack:</h3>
                    <div className="icons-wrapper">
                      {!!caseStudy.frontmatter.technologies.icons &&
                        caseStudy.frontmatter.technologies.icons.map(item => (
                          <div
                            className={`item tech-icon ${item}`}
                            key={item}
                          />
                        ))}
                    </div>
                  </div>
                  <p>{caseStudy.frontmatter.technologies.text}</p>
                </div>
              </div>
              <div className="col-lg-6 col-md-12">
                <div className="expanse-image expanse-absolute technologies-image-wrapper">
                  {techImg && (
                    <Img
                      fluid={techImg.childImageSharp.fluid}
                      alt={caseStudy.frontmatter.info.industry}
                      title={caseStudy.frontmatter.info.industry}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ResultBase;
